import React, { useState } from 'react';
import axios from 'axios';
import ConfirmDialog from '../../../shared/ConfirmDialog';
import CancelButton from '../../../shared/CancelButton';
import SaveButton from '../../../shared/SaveButton';
import { useErrorToast, useDismissError } from '../../../shared/ErrorToastContext';
import CommercialTermsPrompt, { hasCommercialTerms } from './CommercialTermsPrompt';

const WARNING = "It becomes a Customer at Active, keeping everything attached to it. This can't be undone.";

// "Won — Convert to Customer" (vis_relationship_lifecycle.md §6) — shared by
// the record's Relationship card and the Pipeline card menu. One way only,
// so it always asks first; a record without its Tier/Customer Price Group
// yet gets the Tier prompt (which Active needs anyway) as that confirmation
// instead of a second dialog. Cancelling leaves the Prospect untouched.
// onConverted(entity) receives the updated record.
function ConvertToCustomerDialog({ entity, onCancel, onConverted }) {
  const showError = useErrorToast();
  const dismissError = useDismissError();
  const [saving, setSaving] = useState(false);

  const convert = async (terms = {}) => {
    try {
      const res = await axios.post(`/api/commercial-entities/${entity.id}/convert-to-customer`, terms);
      dismissError();
      onConverted(res.data.data);
    } catch (err) {
      showError(err, 'Convert failed');
      throw err;
    }
  };

  if (!hasCommercialTerms(entity)) {
    return (
      <CommercialTermsPrompt
        entity={entity}
        stageName="Active"
        title={`Convert ${entity.name} to Customer`}
        description={`A Customer needs commercial terms. ${WARNING}`}
        confirmLabel="Convert to Customer"
        savingLabel="Converting..."
        onCancel={onCancel}
        onConfirm={convert}
      />
    );
  }

  const confirm = async () => {
    setSaving(true);
    try {
      await convert();
    } catch (err) {
      setSaving(false);
    }
  };

  return (
    <ConfirmDialog
      open
      onOpenChange={(next) => { if (!next && !saving) onCancel(); }}
      title={`Convert ${entity.name} to Customer`}
      description={WARNING}
      footer={(
        <div style={{ display: 'flex', gap: 8 }}>
          <CancelButton onClick={onCancel} disabled={saving} />
          <SaveButton type="button" onClick={confirm} loading={saving}>
            {saving ? 'Converting...' : 'Convert to Customer'}
          </SaveButton>
        </div>
      )}
    />
  );
}

export default ConvertToCustomerDialog;
